import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef
} from "@angular/core";
import {FUIPageService} from "../page.service";
import {FUIResponsiveService} from "../responsive.service";
import {Subscription} from "rxjs";
import {FUIBreakpoints} from "../breakpoints.model";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-page-footer",
    styleUrls: ["./page-footer.component.scss"],
    templateUrl: "./page-footer.component.html",
    standalone: false
})
export class FUIPageFooterComponent implements OnDestroy, OnInit {
    @Input() minimiseOnSmallScreen : false;

    @ContentChild("FUIPageFooterControls", {read: TemplateRef}) public pageFooterControls: TemplateRef<HTMLTemplateElement>;
    @ContentChild("FUIPageFooterButtons", {read: TemplateRef}) public pageFooterButtons: TemplateRef<HTMLTemplateElement>;
    @ContentChild("FUIPageFooterSummary", {read: TemplateRef}) public pageFooterSummary: TemplateRef<HTMLTemplateElement>;
    @HostBinding("class.minimise") public minimise: boolean;

    private subscriptions: Subscription = new Subscription();

    constructor(private pageService: FUIPageService,
                private responsiveService: FUIResponsiveService) {
        this.subscriptions.add(this.pageService.minimise$.subscribe(
            (minimise) => {
                this.minimise = minimise;
            }
        ));
    }

    ngOnInit(): void {

        // For smaller devices, optionally use the minimise functionality to hide the
        // footer when the vertical space is not accommodating (for instance, when an
        // on screen keyboard is activated
        if (this.minimiseOnSmallScreen) {
            if (this.responsiveService.breakpointApplies(FUIBreakpoints.smallDown)) {
                this.minimise = true;
            }

            this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(
                () => {
                    if (this.responsiveService.breakpointApplies(FUIBreakpoints.smallDown)) {
                        this.minimise = true;
                    }
                }
            ));
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
